<mat-card appearance="outlined" *ngIf="transportOrder" class="tw-flex tw-flex-col">
  <div class="tw-flex tw-flex-col tw-gap-y-4">
    <div class="tw-flex tw-gap-x-8 tw-justify-start tw-items-center">
      <a
        [routerLink]="'/dashboard/shipment-to/main-info'"
        [queryParams]="{
          transportOrderNumber: transportOrder.toNumber,
          monitoringPageType: monitoringPageType
        }"
      >
        <h3 class="card-item-number link" cropText>
          {{ 'monitoring.transports.viewMode.transportOrder' | translate }}:
          {{ transportOrder.toNumber }}
        </h3>
      </a>
      <ui-deviation-type *ngIf="transportOrder?.deviation as deviation" [deviation]="deviation"></ui-deviation-type>
      <div class="to__subtitle">
        <div class="item-status">
          {{ transportOrder.status | startCase }}
        </div>
      </div>
      <ui-dates class="to__dates" cropText [dates]="transportOrder.dates" [dateType]="dateType.Departure"></ui-dates>
      <ui-dates class="to__dates" cropText [dates]="transportOrder.dates" [dateType]="dateType.Arrival"></ui-dates>
    </div>

    <div class="tw-flex tw-gap-x-8">
      <ng-container
        *ngFor="
          let item of [
            {
              title: 'monitoring.transports.transportView.consignor' | translate,
              rows: [
                {
                  label: 'common.field.id' | translate,
                  text: transportOrder.consignorExtId
                },
                {
                  label: 'monitoring.transports.transportView.name' | translate,
                  text: transportOrder.consignorName
                },
                {
                  label: 'common.field.address' | translate,
                  text: transportOrder.consignorAddress
                }
              ]
            },
            {
              title: 'monitoring.transports.transportView.consignee' | translate,
              rows: [
                {
                  label: 'common.field.id' | translate,
                  text: transportOrder.recipientExtId
                },
                {
                  label: 'monitoring.transports.transportView.name' | translate,
                  text: transportOrder.recipientName
                },
                {
                  label: 'common.field.address' | translate,
                  text: transportOrder.recipientAddress
                }
              ]
            }
          ]
        "
      >
        <ng-container *ngTemplateOutlet="infoTemplate; context: item"></ng-container>
      </ng-container>
    </div>
  </div>

  <ng-container *ngIf="transportOrder.loads as loads">
    <mat-accordion>
      <ng-container *ngFor="let load of loads">
        <ui-load-info-bar
          [load]="load"
          [loadStatus]="load.webLoadStatusView"
          [monitoringPageType]="monitoringPageType"
          class="load"
        >
          <ng-container header>
            <ui-load-info-bar-header-dates
              [load]="load"
              [loadStatus]="load.webLoadStatusView"
              [hasLabel]="hasLabel"
              [hasSpeedUpInfo]="hasSpeedUpInfo"
            >
            </ui-load-info-bar-header-dates>
          </ng-container>
          <ng-container body>
            <div class="load__details tw-w-full">
              <ng-container
                *ngFor="
                  let item of [
                    {
                      title: 'monitoring.transports.transportView.details.scac' | translate,
                      rows: [
                        {
                          label: '',
                          text: load.scac
                        }
                      ]
                    },
                    {
                      title: 'monitoring.transports.transportView.details.pickup' | translate,
                      rows: [
                        {
                          label: 'common.field.id' | translate,
                          text: load.pickupExtId
                        },
                        {
                          label: 'monitoring.transports.transportView.name' | translate,
                          text: load.pickupName
                        },
                        {
                          label: 'common.field.address' | translate,
                          text: load.pickupAddress
                        }
                      ]
                    },
                    {
                      title: 'monitoring.transports.transportView.details.delivery' | translate,
                      rows: [
                        {
                          label: 'common.field.id' | translate,
                          text: load.deliveryExtId
                        },
                        {
                          label: 'monitoring.transports.transportView.name' | translate,
                          text: load.deliveryName
                        },
                        {
                          label: 'common.field.address' | translate,
                          text: load.deliveryAddress
                        }
                      ]
                    }
                  ]
                "
              >
                <ng-container *ngTemplateOutlet="infoTemplate; context: item"></ng-container>
              </ng-container>
            </div>
          </ng-container>
        </ui-load-info-bar>
      </ng-container>
    </mat-accordion>
  </ng-container>
</mat-card>

<ng-template #infoTemplate let-id="id" let-title="title" let-rows="rows">
  <div class="info">
    <div class="info__title">
      {{ title }}
    </div>
    <div class="info__text">
      <div class="row" *ngFor="let row of rows">
        <span *ngIf="row.label" class="label">{{ row.label }}: </span>
        {{ row.text | nullToNotAvailable }}
      </div>
    </div>
  </div>
</ng-template>
